<template>
  <el-dialog
    title="库存管理"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="80%">
    <div class="stock-info">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="info-item">
            <label>产品名称：</label>
            <span>{{ productInfo.productName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <label>产品编码：</label>
            <span>{{ productInfo.productCode }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <label>当前库存：</label>
            <span :class="getStockClass(stockInfo.currentStock, productInfo.minStock)">
              {{ stockInfo.currentStock || 0 }}
            </span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info-item">
            <label>可用库存：</label>
            <span>{{ stockInfo.availableStock || 0 }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="库存操作" name="operation">
        <el-form :model="operationForm" :rules="operationRules" ref="operationForm" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="操作类型" prop="type">
                <el-select v-model="operationForm.type" placeholder="请选择操作类型" @change="handleTypeChange">
                  <el-option label="入库" value="inbound"></el-option>
                  <el-option label="出库" value="outbound"></el-option>
                  <el-option label="调整" value="adjust"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="数量" prop="quantity">
                <el-input-number v-model="operationForm.quantity" :min="1" placeholder="数量"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="operationForm.type !== 'adjust'">
              <el-form-item label="单价" prop="unitPrice">
                <el-input-number v-model="operationForm.unitPrice" :precision="2" :min="0" placeholder="单价"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="关联类型" prop="referenceType">
                <el-select v-model="operationForm.referenceType" placeholder="请选择关联类型">
                  <el-option label="采购" value="PURCHASE"></el-option>
                  <el-option label="销售" value="SALE"></el-option>
                  <el-option label="耗用" value="CONSUME"></el-option>
                  <el-option label="调整" value="ADJUST"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联ID" prop="referenceId">
                <el-input v-model="operationForm.referenceId" placeholder="关联ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="operationForm.remark" placeholder="备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="submitOperation">执行操作</el-button>
            <el-button @click="resetOperation">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="库存台账" name="ledger">
        <el-table
          :data="ledgerList"
          border
          v-loading="ledgerLoading"
          style="width: 100%;">
          <el-table-column
            prop="id"
            header-align="center"
            align="center"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="transactionType"
            header-align="center"
            align="center"
            label="交易类型">
            <template slot-scope="scope">
              <el-tag :type="getTransactionTypeTag(scope.row.transactionType)">
                {{ getTransactionTypeText(scope.row.transactionType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            header-align="center"
            align="center"
            label="数量">
            <template slot-scope="scope">
              <span :class="scope.row.quantity > 0 ? 'text-success' : 'text-danger'">
                {{ scope.row.quantity > 0 ? '+' : '' }}{{ scope.row.quantity }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="beforeStock"
            header-align="center"
            align="center"
            label="变更前库存">
          </el-table-column>
          <el-table-column
            prop="afterStock"
            header-align="center"
            align="center"
            label="变更后库存">
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            header-align="center"
            align="center"
            label="单价">
            <template slot-scope="scope">
              ¥{{ scope.row.unitPrice }}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            header-align="center"
            align="center"
            label="总金额">
            <template slot-scope="scope">
              ¥{{ scope.row.totalAmount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="referenceType"
            header-align="center"
            align="center"
            label="关联类型">
          </el-table-column>
          <el-table-column
            prop="operatorName"
            header-align="center"
            align="center"
            label="操作员">
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="操作时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormat }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="ledgerSizeChangeHandle"
          @current-change="ledgerCurrentChangeHandle"
          :current-page="ledgerPageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="ledgerPageSize"
          :total="ledgerTotalPage"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        activeTab: 'operation',
        productInfo: {},
        stockInfo: {},
        operationForm: {
          type: 'inbound',
          quantity: 1,
          unitPrice: 0,
          referenceType: 'PURCHASE',
          referenceId: '',
          remark: ''
        },
        operationRules: {
          type: [
            { required: true, message: '操作类型不能为空', trigger: 'change' }
          ],
          quantity: [
            { required: true, message: '数量不能为空', trigger: 'blur' }
          ],
          unitPrice: [
            { required: true, message: '单价不能为空', trigger: 'blur' }
          ]
        },
        ledgerList: [],
        ledgerLoading: false,
        ledgerPageIndex: 1,
        ledgerPageSize: 10,
        ledgerTotalPage: 0
      }
    },
    methods: {
      init (product) {
        this.productInfo = product
        this.visible = true
        this.activeTab = 'operation'
        this.getStockInfo()
        this.getLedgerList()
      },
      // 获取库存信息
      getStockInfo () {
        this.$http({
          url: 'inventory/getCurrentStock',
          method: 'get',
          params: {
            productId: this.productInfo.id
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.stockInfo = data.data || {}
          }
        })
      },
      // 获取台账列表
      getLedgerList () {
        this.ledgerLoading = true
        this.$http({
          url: 'inventory/ledger/page',
          method: 'get',
          params: {
            'page': this.ledgerPageIndex,
            'limit': this.ledgerPageSize,
            'productId': this.productInfo.id
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.ledgerList = data.data.list
            this.ledgerTotalPage = data.data.total
          } else {
            this.ledgerList = []
            this.ledgerTotalPage = 0
          }
          this.ledgerLoading = false
        })
      },
      // 标签页切换
      handleTabClick (tab) {
        if (tab.name === 'ledger') {
          this.getLedgerList()
        }
      },
      // 操作类型改变
      handleTypeChange (type) {
        if (type === 'adjust') {
          this.operationForm.unitPrice = 0
          this.operationForm.referenceType = 'ADJUST'
        } else {
          this.operationForm.referenceType = type === 'inbound' ? 'PURCHASE' : 'SALE'
        }
      },
      // 提交操作
      submitOperation () {
        this.$refs['operationForm'].validate((valid) => {
          if (valid) {
            const params = {
              productId: this.productInfo.id,
              quantity: this.operationForm.quantity,
              unitPrice: this.operationForm.unitPrice,
              referenceType: this.operationForm.referenceType,
              referenceId: this.operationForm.referenceId,
              remark: this.operationForm.remark
            }
            
            let url = ''
            if (this.operationForm.type === 'inbound') {
              url = '/inventory/inbound'
            } else if (this.operationForm.type === 'outbound') {
              url = '/inventory/outbound'
            } else {
              url = '/inventory/adjust'
              params.adjustQuantity = params.quantity
              delete params.quantity
              delete params.unitPrice
              params.reason = params.remark
              delete params.remark
            }
            
            this.$http({
              url: url,
              method: 'post',
              data: params
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.getStockInfo()
                    this.getLedgerList()
                    this.resetOperation()
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      // 重置操作表单
      resetOperation () {
        this.operationForm = {
          type: 'inbound',
          quantity: 1,
          unitPrice: 0,
          referenceType: 'PURCHASE',
          referenceId: '',
          remark: ''
        }
        this.$refs['operationForm'].resetFields()
      },
      // 台账分页
      ledgerSizeChangeHandle (val) {
        this.ledgerPageSize = val
        this.ledgerPageIndex = 1
        this.getLedgerList()
      },
      ledgerCurrentChangeHandle (val) {
        this.ledgerPageIndex = val
        this.getLedgerList()
      },
      // 获取库存样式类
      getStockClass (currentStock, minStock) {
        if (currentStock <= minStock) {
          return 'text-danger'
        } else if (currentStock <= minStock * 1.5) {
          return 'text-warning'
        }
        return 'text-success'
      },
      // 获取交易类型标签
      getTransactionTypeTag (type) {
        const tagMap = {
          'INBOUND': 'success',
          'OUTBOUND': 'danger',
          'ADJUST': 'warning'
        }
        return tagMap[type] || 'info'
      },
      // 获取交易类型文本
      getTransactionTypeText (type) {
        const textMap = {
          'INBOUND': '入库',
          'OUTBOUND': '出库',
          'ADJUST': '调整'
        }
        return textMap[type] || type
      }
    }
  }
</script>

<style scoped>
  .stock-info {
    background: #f5f5f5;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
  }
  .info-item {
    margin-bottom: 10px;
  }
  .info-item label {
    font-weight: bold;
    color: #606266;
  }
  .text-danger {
    color: #f56c6c;
    font-weight: bold;
  }
  .text-warning {
    color: #e6a23c;
    font-weight: bold;
  }
  .text-success {
    color: #67c23a;
  }
</style>
